module.exports = __webpack_public_path__ + "Flag-624.6b9679befac9cde9eff8876c5941554e.svg";